
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 30","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.26 13.144c-.329-1.135-.732-3.113-.732-3.113h-.047s-.403 1.978-.731 3.113l-1.04 3.515h3.571l-1.022-3.515zM57.75 0H31.5v30h26.25A2.245 2.245 0 0060 27.75V2.25A2.245 2.245 0 0057.75 0zM55.5 11.25c0 .619-.506 1.125-1.125 1.125h-1.069c-.647 2.213-2.034 4.444-4.003 6.553a29.05 29.05 0 002.447 1.688c.516.318.684.984.384 1.518l-.74 1.303a1.129 1.129 0 01-1.566.404 32.607 32.607 0 01-3.319-2.335 33.037 33.037 0 01-3.318 2.335 1.128 1.128 0 01-1.566-.404l-.74-1.303c-.3-.525-.132-1.2.393-1.518a26.754 26.754 0 002.447-1.688 21.762 21.762 0 01-1.969-2.41 1.122 1.122 0 01.347-1.602l.61-.366.684-.403c.506-.3 1.162-.16 1.5.319a17.874 17.874 0 001.631 1.959c1.266-1.331 2.231-2.71 2.813-4.05H38.625A1.128 1.128 0 0137.5 11.25v-1.5c0-.619.506-1.125 1.125-1.125h6v-1.5c0-.619.506-1.125 1.125-1.125h1.5c.619 0 1.125.506 1.125 1.125v1.5h6c.619 0 1.125.506 1.125 1.125v1.5zM0 2.25v25.5A2.245 2.245 0 002.25 30H28.5V0H2.25A2.245 2.245 0 000 2.25zm5.522 20.26l5.39-15.854c.16-.46.582-.76 1.07-.76h3.046c.478 0 .91.31 1.069.76l5.39 15.853c.244.732-.29 1.491-1.068 1.491h-2.147a1.125 1.125 0 01-1.078-.806l-.881-2.99h-5.644l-.853 2.98c-.141.479-.582.816-1.079.816H6.592c-.77 0-1.313-.76-1.07-1.49z","fill":"currentColor"}})])
          )
        }
      }
    